<template>
    <transition appear name="fade" v-if="(isActive && (!!validateFnc))">
        <div  class="alert alert-danger dcs-alert"><p v-html="validateFnc"/></div>
    </transition>
</template>

<script>
    export default {
        name: "validateWarning",
        methods: {
        },
        props: {
            warningActive: {
                type: Boolean,
                required: false
            },
            validateFnc: {
            }
        },
        computed: {
            isActive: function() {
                return (!!this.warningActive);
            }
        }
    };
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0
    }
    .dcs-alert.alert {
      margin: 4px;
      padding: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/ValidateWarning.vue